namespace Gamification.Gamification {
    export interface ApiTipiOperazioniForm {
        Nome: Serenity.StringEditor;
    }

    export class ApiTipiOperazioniForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.ApiTipiOperazioni';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ApiTipiOperazioniForm.init)  {
                ApiTipiOperazioniForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(ApiTipiOperazioniForm, [
                    'Nome', w0
                ]);
            }
        }
    }
}
